import { AuctionLotsScroller } from './components/AuctionLotsScroller/AuctionLotsScroller';
import { AuctionLotTracker } from './components/AuctionLotTracker/AuctionLotTracker';
import { AuctionNameAndSettingsBlock } from './components/AuctionNameAndSettingsBlock/AuctionNameAndSettingsBlock';
import { CurrencyCode } from '@liveauctioneers/hammer-ui-liveauctioneers/lotDetail';

type Props = {
    catalogId: number;
    selectedCurrency: CurrencyCode;
    setSelectedCurrency: (currency: CurrencyCode) => void;
};

export const BiddingConsoleLeftSection = ({ catalogId, selectedCurrency, setSelectedCurrency }: Props) => {
    return (
        <div className="flex h-full flex-col gap-md">
            <AuctionNameAndSettingsBlock
                catalogId={catalogId}
                onCurrencyChanged={setSelectedCurrency}
                selectedCurrency={selectedCurrency}
            />
            <div className="flex h-full flex-col overflow-hidden rounded-sm border border-border-secondary">
                <AuctionLotTracker catalogId={catalogId} />
                <AuctionLotsScroller catalogId={catalogId} />
            </div>
        </div>
    );
};
